// App Settings
export const DEFAULT_WID = '91e010a89754e38a'; // NA
// export const DEFAULT_WID = 'c140f0989042b3af'; // TW
// export const DEFAULT_WID = '01e080c810f2a3ed'; // JP
//export const DEFAULT_WID = 'e1b0e0f8b744633e'; // EU
export const VERSION_CHECK = process.env.REACT_APP_VERSION_CHECK;

// Endpoints
export const API_CMS = 'https://widgetstate.votenow.tv/v1/state/';
export const API_GEO = '/api/getregion.json';
export const CONNECT_ENDPOINT = process.env.REACT_APP_VOTE_API_URL;
export const TSMC_PARTNERS = 'https://tsmcassets.interactnow.tv/partners';

// Polling Rate
export const MIN_POLLING_RATE = 5000;

// Routing
export const URL_REGEX = /[^0-9A-Za-z$\-_.+!*'(),]/g;

// Keyboard
export const KEYS = {
  DOWN: 40,
  ESCAPE: 27,
  LEFT: 37,
  RIGHT: 39,
  TAB: 9,
  UP: 38,
};

// Routes
export enum ROUTE {
  HOME = '/',
  CLOSED = '/closed',
  PLENARY_SESSION = '/plenary-session',
  TECHNICAL_SESSION = '/technical-session',
  PARTNER_PAVILION = '/partner-pavilion/:partnerCategory?',
  INNOVATION_ZONE = '/innovation-zone/:innovationZoneCategory?',
  TECHNICAL_TRACKS = '/technical-tracks/:categoryId?',
  PARTNER_DETAIL = '/partner-pavilion/partner/:partnerName/:exhibitId',
  SURVEY = '/survey',
  ACHIEVEMENTS = '/achievements',
  AGENDA = '/agenda',
}

// Guest User Regex
export const GUEST_USER_REGEX = /Guest User.*/;

// STREAM CHAT
export const CHAT_API_KEY = process.env.REACT_APP_CHAT_API_KEY || '';
export const VEH_API_URL = process.env.REACT_APP_VIRTUAL_EVENT_HUB_API_URL || '';
